import { PaperPaymentItemBatch } from "../receipt-page-models/PaperPaymentItem";
import { Epoc } from "../../../_models/Epoc";
import { getRandomMemberFromString } from "../../events-screen/parent-events-mocks/mock-utils-functions";
import { CheckPaymentItem } from "../receipt-page-models/CheckPaymentItem";

export const receiptMockCheckFromBatch = (
  batchItem: PaperPaymentItemBatch
): CheckPaymentItem[] => {
  return batchItem.paymentsItems.map((item, index) => {
    const weeksAfterCheckDue = getRandomMemberFromString(
      `${item.eventName}-${index}-weeksAfterCheckDue`,
      [3, 4, 5, 6, 8, 9, 10, 11, 12, 20]
    );
    return {
      dueDate: ((item.receiptDate as Epoc) +
        30 * 24 * 3600 * 1000 * weeksAfterCheckDue) as Epoc,
      checkNumber: `${batchItem.id * 100000 - +index * 30}`,
      amount: item.amountToPay,
    };
  });
};



// WEBPACK FOOTER //
// ./src/app/admin/receipt/receipt-util-mock/receipt-mock-check-from-batch.ts